import { render, staticRenderFns } from "./WarehouseTerritory.vue?vue&type=template&id=f89b32c0&scoped=true"
import script from "./WarehouseTerritory.vue?vue&type=script&lang=js"
export * from "./WarehouseTerritory.vue?vue&type=script&lang=js"
import style0 from "./WarehouseTerritory.vue?vue&type=style&index=0&id=f89b32c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89b32c0",
  null
  
)

export default component.exports